import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { 
	getCurrentAccount, 
	getUserRoles, 
	getCurrentUser 
} from 'state/selectors'

import RegisterUser from 'components/auth/register-user'
import RegisterAccount from 'components/auth/register-account'
import UserPreferences from 'components/auth/user-preferences'
import EditStaffMember from 'components/auth/edit-staff-member'

import PasswordReset from 'components/auth/password-reset'

import MainHeaderNav from 'sections/main-header-nav'

import withValidateResponse from 'components/validations/withValidateResponse'

class ModalSettings extends Component {
	state = {
		currentTab: 0,
		isLoading: true
	}

	navtabs = []

	changeTab = tab => {
		const tabIndex = this.navtabs.findIndex(loopedTab => {
			return loopedTab.name === tab.name
		})

		this.setState({
			currentTab: tabIndex,
		})
	}

	setLoading = isLoading => {
		this.setState({
			isLoading
		})
	}

	swapAccount = (slug) => {
		this.props.history.push('/' + slug);
	}

	render() {
		const {
			data,
			operation,
			userData,
			closeCallback,
			accountData,
		} = this.props

		const {
			currentTab
		} = this.state

		const type = data.type
		const isEditingOtherUser = data.user && data.user.id !== userData.id

		const user = isEditingOtherUser ? data.user : userData

		if (type === 'user') {
			if(!isEditingOtherUser){
				this.navtabs = [
					{
						name: 'My details',
						content: (
							<RegisterUser
								closeCallback={closeCallback}
								isNew={false}
								isOtherUser={isEditingOtherUser}
								userData={user}
							/>
						)
					},
					{
						name: 'Password',
						content: (
							<PasswordReset 
								closeCallback={closeCallback} 
								userData={user}
								isEditingOtherUser={isEditingOtherUser}
							/>
						)
					},
					{
						name: 'Preferences',
						content: (
							<UserPreferences 
								closeCallback={closeCallback} 
								userData={user} 
							/>
						)
					}
				]
			}else{
				this.navtabs = [{
					name: 'Details',
					content: (
						<EditStaffMember 
							userData={user}
							closeCallback={closeCallback}
						/>
					)
				}]
			}
		} else {
			this.navtabs = [
				{
					name: 'Settings',
					content: (
						<RegisterAccount 
							isCreateNew={operation == 'add'} 
							closeCallback={closeCallback} 
							isNew={false} 
							accountData={accountData} 
							userData={userData}
							hideDomainSuggestion={operation == 'add'}
						/>
					)
				}
			]
		}

		this.navtabs.forEach(tab => {
			tab.isActive = false
		})

		if (this.navtabs.length) {
			this.navtabs[currentTab].isActive = true
		}

		let title

		switch(type){
			case 'user':
				title = isEditingOtherUser ? `${user.first_name} ${user.last_name}` : 'My profile'
				break
			case 'account':
				title = operation == 'add' ? 'Add a new organisation' : 'Organisation settings'
				break
		}

		return (
			<div className={type + '-settings has-tabs'}>
				<div className="modal-tabs-heading">
					<h2>
						{ title }
					</h2>
					{ (type == 'user' && this.navtabs.length > 1) && 
						<MainHeaderNav 
							right={true} 
							callback={this.changeTab} 
							navtabs={this.navtabs} 
							type="settings-tabs" 
						/>
					}
				</div>
				<ul className="settings-tabs-list">
					<li>
						{ this.navtabs[currentTab].content }
					</li>
				</ul>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		allAccounts: state.account.entities.accounts,
		accountData: state.account.accountData,
		userRoles: getUserRoles(state)
	}
}

const ModalSettingsWithValidateResponse = withValidateResponse(ModalSettings)

export default withRouter(connect(mapStateToProps, null)(ModalSettingsWithValidateResponse))
